import React from 'react';
import { View, StyleSheet, Linking, ViewStyle, GestureResponderEvent } from 'react-native';
import { Text, Layout, useTheme, Button, Card, ListItem, Icon, Input } from '@ui-kitten/components';
import { BrandText } from '../components/brandText';
import { ScrollView } from 'react-native-gesture-handler';
import { useScreenDimensions, getItemWidth } from '../utils/useScreenInfo';
import PoallCard from '../components/_primatives/PoallCard';
import { M_UPSERT_EMAIL_LIST_EMAIL } from '../data/api/mutation/m_email_list';
import { useMutation } from '@apollo/react-hooks';



export function HomeScreen({ navigation }): React.ReactElement {
    const theme = useTheme();
    const MAIN_COLOR: string = theme['color-primary-default'];
    const { isMediumScreenOrLarger, isLargeScreenOrLarger } = useScreenDimensions();
    const { bodyWidth } = getItemWidth({ isMediumScreenOrLarger, isLargeScreenOrLarger });

    return (
        <ScrollView style={{ flexGrow: 1 }} contentContainerStyle={{ flexGrow: 1 }}>
            <Layout level='1' style={{ flex: 1,  justifyContent: 'center', alignItems: 'center', paddingTop: 40, paddingBottom: 20 }}>
                <Layout level='1' style={{ maxWidth: bodyWidth, flex: 1,  justifyContent: 'center', alignItems: 'center'}}>
                    {/* header */}
                    <View style={[{ paddingBottom: 40 }, bodyWidth && { flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'space-between' }]}>
                        <View style={{ maxWidth: bodyWidth ? (bodyWidth / 2) - 20 : undefined, justifyContent: 'center', alignItems: 'center', backgroundColor: 'lighgray' }}>
                            {/* <Image
                                resizeMode='contain'
                                style={{ width: 250, height: 250 }}
                                source={poallImages.poall_logo_large}
                            /> */}
                            <BrandText style={{ fontSize: 150, lineHeight: 250  }} status='primary'>pll</BrandText>
                        </View>
                        <View style={{
                            paddingLeft: 20,
                            marginTop: -20,
                            justifyContent: 'center',
                            maxWidth: bodyWidth ? (bodyWidth / 2) - 20 : undefined,
                        }}>
                            <Text category='h1'>{'Poall'}</Text>
                            <View style={{ width: 90, backgroundColor: MAIN_COLOR, height: 4, marginBottom: 10 }}></View>
                            <Text category='h4' style={{ marginBottom: 20 }}>{'Polls and Surveys Made Easy'}</Text>
                        </View>
                    </View>

                    {/* footer */}
                    <View style={[{ paddingBottom: 40 }, bodyWidth && { flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'space-between' }]}>
                        <View style={{ maxWidth: bodyWidth ? (bodyWidth / 2) - 20 : undefined, justifyContent: 'center', alignItems: 'center' }}>
                        <View style={{ flexDirection: 'row' }}>
                                <Button style={{ marginRight: 20}} onPress={() => navigation.navigate('Account', { actionType: 'signup' })}>
                                    {'Sign Up'}
                                </Button>
                                <Button onPress={() => navigation.jumpTo('Product')} appearance='outline'>
                                    {'Learn More'}
                                </Button>
                            </View>
                        </View>
                    </View>
                </Layout>
                <CopyrightFooter />
            </Layout>
        </ScrollView>
    );
}


export function ProductScreen({ navigation }): React.ReactElement {
    const { isMediumScreenOrLarger, isLargeScreenOrLarger } = useScreenDimensions();
    const { bodyWidth, cardWidth, sectionSpace } = getItemWidth({ isMediumScreenOrLarger, isLargeScreenOrLarger });
    console.log('bodyWidth, cardWidth = ', { bodyWidth, cardWidth });



    return (
        <ScrollView style={{ flexGrow: 1 }} contentContainerStyle={{ flexGrow: 1 }}>
            <Layout level='1' style={{ flex: 1, justifyContent: 'flex-start', alignItems: 'center', paddingTop: sectionSpace, paddingBottom: 60 }}>
                <Layout level='1' style={{ maxWidth: bodyWidth,  justifyContent: 'center' }}>
                    
                    {/* header */}
                    <View style={{ marginLeft: 20, marginRight: 20, marginBottom: sectionSpace, alignSelf: 'center' || 'flex-start' }}>
                        <Text category='h1' style={{ textAlign: 'center' }}>
                            {isLargeScreenOrLarger ? `Create Polls & Surveys. Gather Responses.\nView Results.` : 'Create Polls & Surveys.\nGather Feedback.\nView Results.'}
                        </Text>
                    </View>

                    {/* cards */}
                    <View style={[{ marginBottom: sectionSpace }, bodyWidth && { flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'space-around' }]}>
                        {
                            PRODUCT_FEATURES.map((product: Product, index: number) => 
                                <Card
                                    style={{
                                        maxWidth: cardWidth,
                                        width: '100%',
                                        marginBottom: 20,
                                        marginLeft: 0,
                                        marginRight: (isLargeScreenOrLarger && PRODUCT_FEATURES.length !== index + 1) ? 20 : undefined,
                                    }}
                                    key={index}
                                >
                                    <Text category='h2' style={{marginBottom: 20, textAlign: 'center'}}>{product.title}</Text>
                                    {/* <Text category='h5' style={{marginBottom: 5}}>{product.title}</Text> */}
                                    <Text style={{marginBottom: 20, textAlign: 'center'}}>{product.description}</Text>
                                </Card>
                            )
                        }
                    </View>
                    {/* footer */}
                    <View style={[{ paddingBottom: 40 }, bodyWidth && { flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'space-evenly' }]}>
                        <View style={{ maxWidth: bodyWidth ? (bodyWidth / 2) - 20 : undefined, justifyContent: 'center', alignItems: 'center' }}>
                            <View style={{ flexDirection: 'row' }}>
                                <Button style={{ marginRight: 20 }} onPress={() => navigation.navigate('Account', { actionType: 'signup' })}>
                                    {'Get Started'}
                                </Button>
                                <Button onPress={() => navigation.jumpTo('Price')} appearance='outline'>
                                    {'View Plans'}
                                </Button>
                            </View>
                        </View>
                    </View>
                </Layout>
            </Layout>
        </ScrollView>
    );
}


export function PricePlansScreen({ navigation }): React.ReactElement {
    const theme = useTheme();
    const { isMediumScreenOrLarger, isLargeScreenOrLarger } = useScreenDimensions();
    const { bodyWidth, cardWidth, sectionSpace } = getItemWidth({ isMediumScreenOrLarger, isLargeScreenOrLarger });


    return (
        <ScrollView style={{ flexGrow: 1 }} contentContainerStyle={{ flexGrow: 1 }}>
            <Layout level='1' style={{ flex: 1, justifyContent: 'flex-start', alignItems: 'center', paddingTop: sectionSpace, paddingBottom: 60 }}>
                <Layout level='1' style={{ maxWidth: bodyWidth,  justifyContent: 'center' }}>
                    {/* dev only */}
                    {/* <Text>Body Width = {bodyWidth}</Text> */}
                    
                    {/* header */}
                    <View style={{ marginLeft: 20, marginRight: 20, marginBottom: sectionSpace, alignSelf: 'center' || 'flex-start' }}>
                        <Text category='h1' style={{ textAlign: 'center' }}>
                            {'Use the plan that best fits your needs'}
                        </Text>
                    </View>

                    {/* cards */}
                    <View style={[{ marginBottom: sectionSpace }, bodyWidth && { flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'space-around' }]}>
                        {
                            PRICE_PLANS.reverse().map((plan: PricePlan, index: number) =>
                                <PricePlanCard
                                    pricePlan={plan}
                                    onPress={() => navigation.navigate('Account', { actionType: 'signup', planType: plan.routeValue })}
                                    buttonDisabled={plan.routeValue !== PlanTypeOptions.BASIC}
                                    buttonTitle={plan.routeValue !== PlanTypeOptions.BASIC ? 'Coming Soon' : undefined}
                                    style={{
                                        maxWidth: cardWidth,
                                        width: '100%',
                                        marginBottom: 20,
                                        marginLeft: 0,
                                        marginRight: (isLargeScreenOrLarger && PRODUCT_FEATURES.length !== index + 1) ? 20 : undefined,
                                    }}
                                    key={plan.id}
                                />
                            )
                        }
                    </View>
                    {/* footer */}
                    <View style={[{ paddingBottom: 40 }, bodyWidth && { flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'space-evenly' }]}>
                        <View style={{ maxWidth: bodyWidth ? (bodyWidth / 2) - 20 : undefined, justifyContent: 'center', alignItems: 'center' }}>
                            <View style={{ flexDirection: 'row' }}>
                                {/* <Button style={{ marginRight: 20 }} onPress={() => navigation.navigate('Account', { actionType: 'signup' })}>
                                    {'Get Started'}
                                </Button> */}
                                <Button onPress={() => navigation.jumpTo('About')} appearance='outline'>
                                    {'Learn More'}
                                </Button>
                            </View>
                        </View>
                    </View>
                </Layout>
            </Layout>
        </ScrollView>
    );
}


export function AboutScreen(): React.ReactElement {
    const theme = useTheme();
    const MAIN_COLOR: string = theme['color-primary-default'];
    const { isMediumScreenOrLarger, isLargeScreenOrLarger } = useScreenDimensions();
    const { bodyWidth, cardWidth, sectionSpace } = getItemWidth({ isMediumScreenOrLarger, isLargeScreenOrLarger });
    console.log('bodyWidth, cardWidth = ', { bodyWidth, cardWidth });

    return (
        <ScrollView style={{ flexGrow: 1 }} contentContainerStyle={{ flexGrow: 1 }}>
            <Layout level='1' style={{ flex: 1, justifyContent: 'flex-start', alignItems: 'center', paddingTop: sectionSpace, paddingBottom: 60 }}>
                <Layout level='1' style={{ maxWidth: bodyWidth,  justifyContent: 'center' }}>

                    {/* header */}
                    <View style={{ marginLeft: 20, marginRight: 20, marginBottom: sectionSpace, alignSelf: 'center' || 'flex-start' }}>
                        <View style={{ width: 90, borderBottomColor: MAIN_COLOR, borderBottomWidth: 4, marginBottom: 10, alignSelf: 'center' }}>
                            <Text category='h1'>{'Poall'}</Text>
                        </View>
                        <Text category='h1' style={{ textAlign: 'center' }}>
                            {'Working to enable users to quickly and easily create polls and surveys.'}
                        </Text>
                    </View>

                    {/* footer */}
                    <View style={[{ marginBottom: sectionSpace }, bodyWidth && { flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'space-around' }]}>
                        <Card style={{ maxWidth: cardWidth, width: '100%', margin: 5 }}>
                            <Text category='h2' style={{marginBottom: 20, textAlign: 'center'}}>{'Subscribe'}</Text>
                            <Text style={{marginBottom: 20, textAlign: 'center'}}>Subscribe to get updates and announcements sent to your inbox</Text>
                            <SubscriberForm />
                        </Card>
                        <Card style={{ maxWidth: cardWidth, width: '100%', margin: 5 }}>
                            <Text category='h2' style={{marginBottom: 20, textAlign: 'center'}}>{'Contact'}</Text>
                            <Text style={{marginBottom: 20, textAlign: 'center'}}>Feel free to reach out to <Text status='primary' onPress={() => Linking.openURL('mailto://poall_help@outlook.com')}>poall_help@outlook.com</Text> with any questions or comments.</Text>
                            <Button
                                onPress={() => Linking.openURL('mailto://poall_help@outlook.com')}
                                icon={(props) => <Icon name='email' {...props} />}
                                style={{ marginBottom: 20 }}
                            >
                                {`Email`}
                            </Button>
                        </Card>
                        <Card style={{ maxWidth: cardWidth, width: '100%', margin: 5 }}>
                            <Text category='h2' style={{marginBottom: 20, textAlign: 'center'}}>{'Connect'}</Text>
                            <Text style={{marginBottom: 20, textAlign: 'center'}}>Connect with us on Twitter <Text status='primary' onPress={() => Linking.openURL('https://twitter.com/poall_app')}>@poall_app</Text></Text>
                            <Text>{' '}</Text>
                            <Button
                                onPress={() => Linking.openURL('https://twitter.com/poall_app')}
                                icon={(props) => <Icon name='twitter' {...props} />}
                                style={{ marginBottom: 20 }}
                            >
                                {`Twitter`}
                            </Button>
                        </Card>
                    </View>
                </Layout>
            </Layout>
        </ScrollView>
    );
}





interface Product {
    title: string;
    description: string;
}
const PRODUCT_FEATURES: Product[] = [
    {
        title: 'Create',
        description: 'Create polls and surveys quickly with multiple choice, single choice, free form entry, and more!'
    },
    {
        title: 'Gather Responses',
        description: 'Share your poll or survey link with participants.'
    },
    {
        title: 'View Results',
        description: 'Watch results come in and view individual free form answers.'
    },
];

export interface PricePlan {
    id: number;
    title: PlanTypeOptions;
    description: string;
    price: PlanPriceOptions;
    routeValue: string;
    featureList: string[];
}
export enum PlanPriceOptions {
    // PLATINUM = '$19',
    // PREMIUM = '$9',
    PLATINUM = '$--',
    PREMIUM = '$--',
    BASIC = 'Free',
}
export enum PlanTypeOptions {
    PLATINUM = 'Platinum',
    PREMIUM = 'Premium',
    BASIC = 'Basic',
    PARTICIPANT = 'Participant'
}

export const PRICE_PLANS: PricePlan[] = [
    {
        id: 3,
        title: PlanTypeOptions.PLATINUM,
        description: 'Make Poall your own, including 24/7 support, custom themes, and branding',
        price: PlanPriceOptions.PLATINUM,
        routeValue: PlanTypeOptions.PLATINUM,
        featureList: [
            'Customize Theme',
            'Use Your Own Branding',
            'Email Support (Response Within 24 Hours)',
            'All Features From Premium',
            'All Features From Basic',
        ]
    },
    {
        id: 2,
        title: PlanTypeOptions.PREMIUM,
        description: 'Get serious with all the basics plus increased options and support',
        price: PlanPriceOptions.PREMIUM,
        routeValue: PlanTypeOptions.PREMIUM,
        featureList: [
            'Private Polls',
            'Private Surveys',
            'Additional Questions Types',
            'Email Support (Response Within 48 Hours)',
            'All Features From Basic',
        ]
    },
    {
        id: 1,
        title: PlanTypeOptions.BASIC,
        description: 'Get started with Poall and use the basics',
        price: PlanPriceOptions.BASIC,
        routeValue: PlanTypeOptions.BASIC,
        featureList: [
            'Create Polls',
            'Create Surveys',
            'Share via link',
            'View Results in real time',
        ]
    },
];


export interface PricePlanCardProps {
    pricePlan: PricePlan;
    onPress?: () => undefined;
    buttonDisabled?: boolean;
    buttonTitle?: string;
    onCardPress?: (event?: GestureResponderEvent) => void;
    actionItem?: any;
    style?: ViewStyle;
}
export const PricePlanCard = ({ pricePlan, actionItem, onCardPress, onPress, buttonDisabled, buttonTitle, style } : PricePlanCardProps) => (
    <Card style={style} onPress={onCardPress}>
        <Text category='h2' style={{ marginBottom: 20, textAlign: 'center' }}>{pricePlan.title}</Text>
        <Text style={{ marginBottom: 20, textAlign: 'center' }}>{pricePlan.description}</Text>
        {pricePlan.price && <Text category='h2' style={{ marginBottom: 20, textAlign: 'center' }}>{pricePlan.price}</Text>}
        {actionItem ?
            actionItem
            : <Button onPress={onPress} style={{ marginBottom: 20 }} disabled={buttonDisabled}>
                {buttonTitle ? buttonTitle : `Start ${pricePlan.routeValue}`}
            </Button>
        }
        {
            pricePlan.featureList.map((feature: string, index: number) =>
                <ListItem
                    title={`${feature}`}
                    icon={(style) => <Icon {...style} name='checkmark' fill={'green'} />}
                    key={index}
                    style={{ marginLeft: -10, paddingLeft: 0 }}
                />
            )
        }
    </Card>
);

const CopyrightFooter = () => {
    const text: string = `©2020${(new Date().getFullYear()) > 2020 ? '-' + (new Date().getFullYear()) : ''}, Poall`;
    return (
        <>
            <Text appearance='hint'>{text}</Text>
        </>
    );
}







interface SubscriberFormProps {}
const useInputChanges = (initialValue = '', initialIsRequired = true) => {
    const [value, setValue] = React.useState(initialValue);
    const [error, setError] = React.useState(undefined);
    const [isRequired, setIsRequired] = React.useState(initialIsRequired);
    return {
        value,
        caption: error,
        status: error ? 'danger' : undefined,
        setError,
        setIsRequired,
        onChangeText: setValue,
    };
};

const SubscriberForm = (props: SubscriberFormProps) => {
    const [upsertSubscriber, upsertSubscriberResponse] = useMutation(M_UPSERT_EMAIL_LIST_EMAIL);
    const emailInput = useInputChanges();
    const _checkInputs =() => {
        let inputsValid: boolean = true;
        if (!emailInput.value || emailInput.value.length < 1) {
            emailInput.setError('Email is requried');
            inputsValid = false;
        }
        else {
            emailInput.setError(undefined);
        }

        return inputsValid;
    }
    const _onSubmit = async () => {
        if (_checkInputs() === false) {
            return;
        }

        const params = {
            email: emailInput.value,
            subscribed: true
        }
       
        const upsertSubscriberResult: any = await upsertSubscriber({ variables: params});
        console.log('createSurveyResult', upsertSubscriberResult);
        if (upsertSubscriberResult?.data?.insert_email_list?.affected_rows > 0) {
            alert(`You've successfully subscribed!`);
            emailInput.onChangeText('');
            return;
        }
        
        // there was an error
        alert('There was an error, please try again. If you keep seeing this issue, try refreshing the page');
    }


    return (
        
            <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start'}}>
                <Input
                    placeholder='my@email.com'
                    style={{ flex: 1, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                    {...emailInput}
                />
                <Button onPress={_onSubmit} style={{ marginLeft: -1, borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderWidth: 0 }}>
                    {`Subscribe`}
                </Button>
            </View>
        
    );
};